// react
import React, {useEffect, useState} from 'react'
// antd
import {Drawer} from 'antd'
import AppListCard from '@/pages/company/detail/appList'
import FlowListCard from '@/pages/company/detail/flowList'
// less
import './index.less'
// api
import Api from '@/api'

interface IProps {
  close: (reload?: boolean) => void
  corpId: string
}

interface CompanyInfoType {
  corpId: string
  corpName: string
  appInfos: Array<any>
}


/**
 * 企业详情
 * @constructor
 */
const DetailDrawer = (props: IProps) => {

  const [Open, setOpen] = useState<boolean>(true)
  const [AppListLoading, setAppListLoading] = useState<boolean>(true)
  const [DetailInfo, setDetailInfo] = useState<CompanyInfoType>()

  /**
   * 获取企业信息
   */
  const getInfo = async () => {
    setAppListLoading(true)
    const _data: any = await Api.Company.CompanyDetail({corpId: props.corpId}).finally(() => setAppListLoading(false))
    if (_data) {
      setDetailInfo(_data)
    }
  }

  useEffect(() => {
    if (props.corpId) {
      getInfo()
    }
  }, [props.corpId])

  /**
   * 关闭
   * @param reload
   */
  const close = (reload?: boolean) => {
    setOpen(false)
    const _timeOut = setTimeout(() => {
      props.close(reload)
      clearTimeout(_timeOut)
    }, 500)
  }


  return (
    <Drawer
      title={DetailInfo?.corpName}
      width={"100%"}
      open={Open}
      keyboard={false}
      onClose={() => close(false)}
      className={"company-detail-drawer "}
    >
      <AppListCard
        list={DetailInfo?.appInfos || []}
        loading={AppListLoading}
        reload={getInfo}
        corpId={props.corpId}
      />
      <FlowListCard corpId={props.corpId}/>
    </Drawer>
  )
}

export default DetailDrawer
